<template>
  <div class="child mt-5 pl-auto ml-auto mr-auto pr-auto" style="width: 100% !important;background-color: #F5F5F5" :style="{ filter: getBright }" v-if="languageData.labels">
    <v-row class="mt-3" no-gutters>
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 2 : 12">
        <v-text-field
            class="ml-5"
            v-model="value.number"
            :label="'No'"
            disabled
        ></v-text-field>
      </v-col>
      <v-col :cols="$vuetify.breakpoint.mdAndUp ?  5 : 12">
        <v-text-field
            class="ml-5"
            v-model="value.name"
            :rules="[(v) => !!v || languageData.validationEstimate.name_required]"
            :label="languageData.labels.name"
            :placeholder="languageData.labels.name"
            :disabled="isPreview || isMeasurement"
        ></v-text-field>
      </v-col>
      <v-col v-if="value.visibleInput && showVat && !isMeasurement" :cols="$vuetify.breakpoint.mdAndUp ? 5 : 12">
        <v-select
            @change="calculateTotalPrice"
            :label="languageData.labels.vat"
            v-model="value.vat"
            :items="vatData"
            class="ml-5"
            item-value="value"
            item-text="label"
            :disabled="isPreview || isMeasurement"
            return-object>
          <template slot='selection' slot-scope='{ item }'>
            {{ languageData.vatLabels[item.label] }}
          </template>
          <template slot='item' slot-scope='{ item }'>
            {{ languageData.vatLabels[item.label] }}
          </template>
        </v-select>
      </v-col>
      <v-col v-if="level === 0" :cols="$vuetify.breakpoint.mdAndUp ? 5 : 12">
        <v-btn
            v-if="level !== 0 && value.visibleInput === true && isMeasurement"
            color="primary"
            @click="addDetail"
        >
          {{ languageData.btnAddDetails }}
        </v-btn>
        <v-textarea
            v-if="!isMeasurement"
            class="ml-5"
            v-model="value.description"
            auto-grow
            rows="1"
            :label="languageData.labels.description"
            :disabled="isPreview || isMeasurement"

        ></v-textarea>
      </v-col>
       <v-col v-if="level !== 0" :cols="$vuetify.breakpoint.mdAndUp ? 11 : 9" class="d-flex justify-start">
        <v-btn
            v-if="level !== 0 && value.visibleInput === true && isMeasurement"
            color="primary"
            class="ml-5"
            @click="addDetail"
        >
          {{ languageData.btnAddDetails }}
          <span v-on:click.stop @click="openGuidesModal('measurementGuide')" class="guides-question-mark" style="background-color: #fff; color: #FFA400;">?</span>
        </v-btn>
        <v-textarea
            v-if="!isMeasurement"
            v-model="value.description"
            auto-grow
            rows="1"
            class="ml-5"
            :label="languageData.labels.description"
            :disabled="isPreview || isMeasurement"

        ></v-textarea>
      </v-col>
      <v-col cols="1" v-if="level !== 0" class="mt-3">
        <v-btn
          v-if="level !== 0 && value.visibleInput === true && !isPreview && !isMeasurement"
          color="fontDefault"
          @click="$emit('delete')"
        >
          <v-icon style="color: white !important;">
            mdi-trash-can
          </v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12">
        <div class="children-wrapper" v-if="value.children.length">    
              <Instance
                v-for="(instance, key) in value.children"
                v-model="value.children[key]"
                :key="instance.id"
                :level="level + 1"
                :id="instance.id"
                :showVat="showVat"
                :vatData="vatData"
                @delete="showDeleteModal(instance)"
                :disabled="level < 1"
                :isPreview="isPreview || isMeasurement"
                :isMeasurement="isMeasurement"
            ></Instance>
        </div>
      </v-col>
      <v-col cols="12" class="text-left ml-3 mt-3">
        <v-tooltip top v-if="!isPreview && !isMeasurement">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                color="primary"
                v-if="(value.visibleInput === true && level === 0) || value.visibleInput === false"
                @click="addChild(value.id)"
                class="mr-5"
                :class="{'mb-5': $vuetify.breakpoint.xsOnly}"
            >
              <v-icon dark>
                mdi-plus
              </v-icon>
            </v-btn>
          </template>
          <span>
            {{ languageData.labels.add_position }}
          </span>
        </v-tooltip>
        <v-btn
          v-if="!value.visibleInput && !isLevelZero && !isPreview"
          color="fontDefault"
          class="mr-5"
          @click="$emit('delete')"
          :class="{'mb-5': $vuetify.breakpoint.xsOnly}"
        >
          <v-icon style="color: white !important;">
            mdi-trash-can
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="value.visibleInput" :key="totalPriceRow">
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 2 : 12">
        <v-select
            v-if="value.visibleInput"
            :label="languageData.labels.uom"
            v-model="value.uom"
            :rules="[(v) => !!v || languageData.validationEstimate.uom_required]"
            :items="measureTypesEnum"
            :placeholder="languageData.labels.uom"
            class="ml-5"
            item-value="value"
            item-text="name"
            :disabled="isPreview || isMeasurement"
            required
            return-object>
          <template slot='selection' slot-scope='{ item }'>
            {{ languageData.measureTypes[item.value] }}
          </template>
          <template slot='item' slot-scope='{ item }'>
            {{ languageData.measureTypes[item.value] }}
          </template>
        </v-select>
      </v-col>
      <template v-if="!isMeasurement">
        <v-col :cols="$vuetify.breakpoint.mdAndUp ? 2 : 12">
          <v-text-field
              v-if="!isMeasurement"
              class="ml-5"
              :label="languageData.labels.price"
              v-model.number="value.price"
              type="number"
              :rules="[(v) => !!v || languageData.validationEstimate.price_required,  v => ( v && v < 1000000000 ) || languageData.validationEstimate.max_price,]"
              @change="calculateTotalPrice"
              :placeholder="languageData.labels.price"
              :disabled="isPreview"
          ></v-text-field>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="1" class="text-center">
          <v-icon
              v-if="!isMeasurement"
              style="line-height: 2.5 !important;">mdi-close</v-icon>
        </v-col>
      </template>
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? isMeasurement ? 5 : 2 : 12">
        <v-text-field
            class="ml-5"
            :label="languageData.labels.quantity"
            v-model.number="value.quantity"
            type="number"
            step="0.001"
            :rules="[(v) => !!v || languageData.validationEstimate.quantity_required]"
            @change="calculateTotalPrice"
            :placeholder="languageData.labels.quantity"
            :disabled="isPreview || isMeasurement"
        ></v-text-field>
      </v-col>
      <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="1" class="text-center">
        <v-icon
            v-if="!isMeasurement"
            style="line-height: 2.5 !important;">mdi-equal</v-icon>
      </v-col>
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 2 : 12">
        <v-text-field
            v-if="!isMeasurement"
            class="ml-5"
            :label="languageData.labels.net_value"
            v-model.number="value.total_net"
            :rules="[v => ( v && v < 1000000000 ) || languageData.validationEstimate.max_total_net,]"
            type="number"
            disabled
            :placeholder="languageData.labels.net_value"></v-text-field>
      </v-col>
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 2 : 12">
        <v-text-field
            v-if="!isMeasurement"
            class="ml-5"
            :label="languageData.labels.gross_value"
            v-model.number="value.total_gross"
            :rules="[v => ( v && v < 1000000000 ) || languageData.validationEstimate.max_total_gross,]"
            type="number"
            disabled
            :placeholder="languageData.labels.gross_value"
        ></v-text-field>
      </v-col>
    </v-row>
    <div v-if="isMeasurement">
      <v-row
          class="ml-2"
          v-for="(detail, index) in value.measurementDetails" v-bind:key="index">
        <v-col :cols="$vuetify.breakpoint.mdAndUp ? 3 : 12">
          <v-text-field
              :label="languageData.labels.description"
              v-model="detail.description"
              :rules="[
                  v => !!v || languageData.measurements.description_required
              ]"
          >
          </v-text-field>
        </v-col>
        <v-col :cols="$vuetify.breakpoint.mdAndUp ? 3 : 12">
          <v-text-field
              :label="languageData.labels.measurementValue"
              type="number"
              step="0.001" min="0.000" max="99999.999"
              :rules="[
                  v => !!v || languageData.measurements.detail_value_required,
                  v => /^\d+(\.\d{1,3})?$/.test(v) || languageData.measurements.fsf_format
              ]"
              v-model="detail.value"
          >
          </v-text-field>
        </v-col>
        <v-col cols="1" class="d-flex justify-center align-center">
          <v-btn
              class="ml-10"
              height="30"
              color="fontDefault"
              @click="showDeleteDetailModal(detail)"
          >
            <v-icon
                color="white"
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <v-row
        class="mx-5"
        v-if="value.measurementDetails !== undefined && value.measurementDetails.length > 0 && isMeasurement">
      <v-col cols="4">

      </v-col>
    </v-row>
    <ModalInfo @doOperation="deleteChild(instanceToDelete)" :typeInfo="'success'" :headModal="languageData.modalSuccess.head" :btnDisAgreeText="languageData.btnDisAgreeText" :btnAgreeText="languageData.btnAgreeText" :visDisAgreeBtn="true" @clicked="hideModalDeleteInfo" :show-modal="isShowDeleteModalInfo" :text-modal="languageData.modalSuccess.text + instanceToDelete.name + '?'"></ModalInfo>
    <ModalInfo @doOperation="deleteParent()" :typeInfo="'success'" :headModal="languageData.modalSuccess.head" :btnDisAgreeText="languageData.btnDisAgreeText" :btnAgreeText="languageData.btnAgreeText" :visDisAgreeBtn="true" @clicked="hideModalDeleteParentInfo" :show-modal="isShowDeleteParentModalInfo" :text-modal="languageData.modalSuccess.text + parentToDelete.name + '?'"></ModalInfo>
    <ModalInfo
        @doOperation="deleteDetail(detailToDelete)"
        :isLoadingBtn="false"
        :idData="modalDeleteData.idData"
        :typeInfo="modalDeleteData.languageData.typeInfo"
        :headModal="modalDeleteData.languageData.head"
        :btnDisAgreeText="modalDeleteData.languageData.btnDisAgreeText"
        :btnAgreeText="modalDeleteData.languageData.btnAgreeText"
        :vis-agree-btn="true"
        :visDisAgreeBtn="true"
        @clicked="hideModalDelete"
        :show-modal="isShowDeleteDetailModalInfo"
        :text-modal="modalDeleteData.languageData.textInfo">
    </ModalInfo>
  </div>
</template>

<style src="./Instance.scss" lang="scss"></style>

<script type="text/javascript">
  import currency from "currency.js"
  import {Child} from "../../helpers/child";
  import {mapActions, mapState} from "vuex";
  import Instance from "./Instance";
  import eventBus from "../../../../event-bus/eventBus";
  import measureTypesEnum from "../../../../enums/measureTypes";
  import ModalInfo from "../../../../components/ModalInfo/ModalInfo";

  export default {
    name: "Instance",
    props: {
      level: Number,
      value: Object,
      id: Number,
      vatData: Array,
      isPreview: Boolean,
      isMeasurement: Boolean,
      showVat:[Boolean, String],
    },
    components: {
      Instance,
      ModalInfo,
    },
    data() {
      return {
        model: {
          children: []
        },
        isShowDeleteModalInfo: false,
        isShowDeleteParentModalInfo: false,
        modalDeleteInfoData: {
          typeInfo: "",
          head: "",
          textInfo: ""
        },
        instanceToDelete: {},
        parentToDelete: {},
        categoryToDelete: {},
        detailToDelete: {},
        measureTypesEnum: measureTypesEnum,
        totalPriceRow: 0,
        isShowDeleteDetailModalInfo: false,
        modalDeleteData: {
          idData: 0,
          languageData: {}
        },
        maxPercent: 100,
        minPercent: 1,
      }
    },
    methods: {
      ...mapActions("getVat", ["getVat"]),
      ...mapActions("showEstimationModal", ["updateMeasurementInEdit", "updateVisibleEstimationModal"]),
      ...mapActions("updateVisibleGuideModal", ["updateGuidesModalVisible"]),
      ...mapActions("preventDataLost", ["updateDataInFormIsChanged"]),

      calculateTotalPrice: function() {
        if(this.value.price) {
          this.value.price = currency(this.value.price);
        }

        if(this.value.quantity) {
          this.value.quantity =  currency(this.value.quantity, { precision: 3 });
        }

        if(this.value.quantity && this.value.price) {
          this.value.total_net = currency(this.value.price).multiply(this.value.quantity);
          this.value.total_gross = this.value.total_net;
          if(this.showVat) {
            this.value.total_gross = currency(this.value.total_gross).multiply(1+(this.value.vat.value / 100));
          }
          this.totalPriceRow += 1;
        } else {
          this.value.total_net = 0;
          this.value.total_gross = 0;
        }
      },
      addChild: function(id) {
        this.value.children.push(new Child(id, true, this.showVat, this.vatData.find(({label}) => label === 'V_19')));
        eventBus.$emit('refreshEstimationNumbers');
      },
      addSubcategory (id) {
        this.value.children.push(new Child(id, false));
        eventBus.$emit('refreshEstimationNumbers');
      },
      showDeleteModal: function(instance) {
        this.instanceToDelete = instance;
        this.isShowDeleteModalInfo = true;
      },
      hideModalDeleteInfo: function() {
        this.isShowDeleteModalInfo = false;
      },
      showDeleteParentModal: function(parent) {
        this.parentToDelete = parent;
        this.isShowDeleteParentModalInfo = true;
      },
      hideModalDeleteParentInfo: function() {
        this.isShowDeleteParentModalInfo = false;
      },
      deleteChild: function(child) {
        this.value.children.splice(this.value.children.indexOf(child), 1);
        if(this.value.children.length === 0) {
          this.value.visibleInput = false;
        }
        if(child.visibleInput === true) {
          eventBus.$emit("deleteItem", child.id);
        } else {
          eventBus.$emit("deleteCategory", child.id);
        }
      },
      deleteParent() {
        eventBus.$emit("deleteParent", this.parentToDelete);
      },
      deleteDetail (item) {
        this.value.measurementDetails.splice(this.value.measurementDetails.indexOf(item), 1);
        eventBus.$emit('deleteDetail', item.id);
      },
      assignVat() {
        if(this.showVat !== undefined && this.showVat === true) {
          if(this.value.visibleInput && this.vatData.length > 0) {
            this.$set(this.value, 'vat', typeof(this.value.vat) === 'object' ? this.value.vat.value : this.value.vat);
            this.$set(this.value, 'vat', this.vatData.find(({value}) => value === parseFloat(this.value.vat)));
            this.calculateTotalPrice();
          }
        }
      },
      updateNumbersEmit() {
        eventBus.$emit('updateNumbers');
      },
      addDetail() {
        this.value.measurementDetails.push({
          description: '',
          value: null,
        });
        this.updateMeasurementInEdit(true);
      },
      showDeleteDetailModal (item) {
        this.detailToDelete = item;
        this.modalDeleteData.idData  = this.value.measurementDetails.indexOf(item);
        this.modalDeleteData.languageData = this.languageData.modalDeleteMeasurementDetail;
        this.isShowDeleteDetailModalInfo = true;
      },
      hideModalDelete () {
        this.isShowDeleteDetailModalInfo = false;
      },
       openGuidesModal(guideKey) {
        this.updateGuidesModalVisible({
          isGuidesModalVisible: true,
          guideKey
        });
      },
    },
    computed: {
      ...mapState("showEstimationModal", {
        measurementId: state => state.measurementId
      }),

      getBright: function() {
        let brightPercentage = 100 - 2 * this.level;
        return 'brightness(' + brightPercentage + '%)';
      },
      isLevelZero: function() {
        return this.level === 0;
      },
      // qtyFinishedUom() {
      //   let sum = parseFloat(this.value.measurementDetails.reduce((acc, item) => acc + parseFloat(item.value !== null ? item.value : 0) * 1000, 0)) / 1000;
      //   return isNaN(sum) ? 0.000 : sum;
      // },
      // uomToFv() {
      //   if(this.value.measurementDetails.every(el => el.FSF > 0 && el.value > 0)) {
      //     return parseFloat(this.value.measurementDetails.reduce((previousValue, currentValue) => previousValue + (parseFloat(currentValue.value) * (parseFloat(currentValue.FSF) / 100)), 0));
      //   } else {
      //     return 0;
      //   }
      // },
      disableFsf() {
        return this.value.measurementDetails !== undefined && this.value.measurementDetails.length === 0;
      },
    },
    mounted() {
      this.assignVat();
      eventBus.$on("saveMeasurementSuccess", () => {
        this.updateMeasurementInEdit(false);
        this.updateDataInFormIsChanged(false);
        this.updateVisibleEstimationModal(false);
      });

      eventBus.$on("openCreateMeasurementModal", () => {
        this.value.measurementDetails = [];
        // this.value.FSF = null;
      });

      eventBus.$on("assignVatEstimate", () => {
        this.$nextTick(() => {
          this.assignVat();
        })
      });


    },
  }
</script>